module.exports = __webpack_public_path__ + "static/media/homeLogo.56a09c25.png";